export enum RankingWarningMode {
  NoMatch = 'NoMatch',
  NoMetric = 'NoMetric',
  NoRank = 'NoRank',
  NoPercent = 'NoPercent'
}
